import './App.css';
import KabamWelcomeExperience from './KabamWelcomeExperience';

function App() {
  return (
    <div className="App">
  <KabamWelcomeExperience />
    </div>
  );
}

export default App;
